import { useHeaderMeQuery } from '../../graphql'
import HeaderComponent from './HeaderComponent'

const DefaultSimplifiedHeader = () => {
  const { data, error } = useHeaderMeQuery()

  if (error) {
    throw new Error(error.message)
  }

  const username = data?.me?.firstName
  const avatar = data?.me?.profilePicture?.xSmall
  const goToMyProfile = '/u'
  const goBackToWebsite = '/'

  return (
    <HeaderComponent
      username={username}
      avatar={avatar}
      goBackToWebsite={goBackToWebsite}
      goToMyProfile={goToMyProfile}
    />
  )
}

export default DefaultSimplifiedHeader
